export default {
	tabs: ["Retrait", "Historique"],
	History: {
		tabs: ["Révision", "Succès", "Rejet"]
	},
	Withdraw: {
		label: ["Numéro de compte", "Numéro d'ordre", "Adresse", "Montant", "Frais", "Créé à", "Statut", "Motif"]
	},
	AccountAmount: "Montant du compte",
	tips: "Vous recevrez votre retrait dans l'heure qui sui ",
	form: {
		label: ["Montant du retrait", "Mot de passe de la transaction"],
		ALL: "ALL",
		Withdraw: "Soumettre"
	},
	WithdrawAccount: "Retirer le compte",
	noAccountsTips: "Veuillez ajouter des méthodes de paiement",
	tradingKind: [
		"Remboursement",
		"Déduction",
		"Recharge",
		"Retrait en cours",
		"Déblocage du retrait",
		"Retrait",
		"Tâche",
		"Retour du principal",
		"Retour de commission",
		"Retour de commission subordonnée",
		"Enregistrement",
		"Frais de traitement",
		"Dépôt",
		"Récompense",
		"Salaire de base",
		"Aide en espèces",
		"Bonus d’inscription",
		"Dividendes de produits",
		"Bonus de tâche",
		"Autres",
		"",
		"Bonus de travail",
		"Récompenses de mise à niveau",
		"Subvention",
		"Vérification en attente",
		"Campagne",
		"Échange de points",
		"Récompenses de connexion",
		"Récompenses de travail",
		"Transaction de score de crédit"
	]
};
